var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.998,
    height: 15.998,
    viewBox: "0 0 11.998 15.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "padlock",
    transform: "translate(-5 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87302",
    "data-name": "Path 87302",
    d: "M11,1A4.481,4.481,0,0,0,6.5,5.5v2A1.473,1.473,0,0,0,5,9v6.5A1.473,1.473,0,0,0,6.5,17h9A1.473,1.473,0,0,0,17,15.5V9a1.473,1.473,0,0,0-1.5-1.5v-2A4.481,4.481,0,0,0,11,1Zm5,8v6.5a.472.472,0,0,1-.5.5h-9a.472.472,0,0,1-.5-.5V9a.472.472,0,0,1,.5-.5h9A.472.472,0,0,1,16,9ZM7.5,7.5v-2a3.5,3.5,0,1,1,7,0v2Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.610cff866d0e3a7695e58bf0a0e788f8.svg";
export { ForwardRef as ReactComponent };